<!-- //
dialog 群组添加
@auth xuyd
@date 2023-11-09
//-->
<template>
  <el-dialog
      class="dialog-container"
      :title="title"
      :visible.sync="visible"
      :modal="true"
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      :show-close="true"
      top="10vh"
      width="500px">
    <div>
      <el-form @submit.native.prevent ref="refForm" :model="form" :rules="rules" size="small" label-width="100px" class="quality-form">
        <el-row class="flow-row">
          <el-form-item prop="title" label="标题">
            <el-input size="small" v-model="form.title"/>
          </el-form-item>
        </el-row>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="hideModal">取 消</el-button>
      <el-button size="small" type="primary" @click="handleOk">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>

import WikiApi from '@/api/wiki/wiki.api.js'

export default {
  name: 'ViewGroupAdd',
  data() {
    return {
      visible: false,
      title: '添加组',
      opts: {},
      form: {
        title: null,
      },
      rules: {
        title: [{required: true, message: "请输入标题", trigger: 'blur'}],
      },
    }
  },
  methods: {
    showModal({data, onOk}) {
      let that = this;
      this.dialogShow({
        data: data,
        onOk(data) {
          let promise = onOk && onOk(data);
          if (promise) {
            promise.then(() => {
              that.hideModal();
            }).catch(err => {
              console.log(err)
            })
          }
        },
      })
    },
    dialogShow(opts) {
      this.visible = true;
      this.opts.onOk = opts.onOk
      this.opts.onCancel = opts.onCancel
      if (!opts.data) {
        opts.data = {};
      }
      opts.data = this.$util.mergeObject(this.form, opts.data)
      this.form = opts.data
    },

    hideModal() {
      this.visible = false;
      this.$refs["refForm"].clearValidate();
      this.$refs["refForm"].resetFields();
    },

    /**
     * 点击确定
     */
    handleOk() {
      this.$refs.refForm.validate(valid => {
        if (valid) {
          return WikiApi.saveWikiGroup(this.form).then(resp => {
            this.$modal.msgSuccess("添加成功")
            this.opts.onOk(resp.data);
            this.hideModal();
          });
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.quality-form {
  /** el版本低的问题，需要加如下 */

  //.el-transfer-panel__item {
  //  display: block !important;
  //}
  //
  //.el-transfer-panel {
  //  width: 250px;
  //  height: 400px;
  //}
  //
  //.el-transfer-panel__list.is-filterable {
  //  width: 250px;
  //  height: 300px;
  //}
}
</style>
